























































import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import suiviConsoMixin from './suiviConsoMixin'
import { Chart, ChartConfiguration, ChartData, ChartOptions, registerables } from 'chart.js'
Chart.register(...registerables)
import ChartDataLabels from 'chartjs-plugin-datalabels'
import _ from 'lodash'
import Openable from '@/global/viewmodels/openable'
Chart.register(ChartDataLabels)

const colors = ['#7fdbff', '#0074d9', '#01ff70', '#001f3f', '#39cccc', '#3d9970', '#2ecc40', '#ff4136', '#85144b', '#ff851b', '#b10dc9', '#ffdc00', '#f012be', '#aaaaaa', '#111111', '#dddddd']

export default mixins(suiviConsoMixin, mobileTypeMixin).extend({
    components: {
        BAlert: () => import('@/layout/components/BiobankAlert.vue')
    },
    data() {
        return { alert: new Openable() }
    },
    mounted() {
        this.reload()
        this.alert.open()
    },
    computed: {
        config(): ChartConfiguration {
            const that = this
            const baseOptions: ChartOptions = {
                responsive: true,
                plugins: {
                    legend: {
                        fullSize: true,
                        align: 'start',

                        position: this.isMobileDevice() ? 'top' : 'left',
                        onClick: function(event, elem) {
                            if (!that.codeFamilleSelectionne) {
                                // @ts-ignore
                                const data = that.suiviConso?.codeFamille[elem.index]
                                if (data) {
                                    that.codeFamilleSelectionne = data
                                    that.$nextTick(() => that.generateChart())
                                }
                            }
                        }
                    },
                    datalabels: {
                        backgroundColor: function(context: any) {
                            return context.dataset.backgroundColor
                        },
                        borderColor: 'white',
                        borderRadius: 25,
                        borderWidth: 2,
                        color: 'white',
                        display: function() {
                            return true
                        },
                        font: {
                            weight: 'bold'
                        },
                        padding: 6,
                        formatter: Math.round
                    }
                },
                // Core options
                layout: {
                    padding: 16
                },
                animation: {
                    duration: 500
                }
            }
            if (!this.suiviConso)
                return {
                    type: 'doughnut' as 'doughnut',
                    data: {
                        labels: [],
                        datasets: []
                    },
                    options: baseOptions
                }
            if (!this.codeFamilleSelectionne) {
                const labels = this.suiviConso.codeFamille
                    .map(code => `${this.suiviConso?.statsGlobalesFamilles[code].libelleFamille} (${this.suiviConso?.statsGlobalesFamilles[code].nombreArticle})`)
                    .sort((a, b) => a.localeCompare(b))
                    .filter(function(x): x is string {
                        return x !== undefined
                    })
                const data = this.suiviConso.codeFamille
                    .sort((a, b) => (this.suiviConso?.statsGlobalesFamilles[a].libelleFamille ?? '').localeCompare(this.suiviConso?.statsGlobalesFamilles[b].libelleFamille ?? ''))
                    .map(code => this.suiviConso?.statsGlobalesFamilles[code].nombreArticle)
                    .filter(function(x): x is number {
                        return x !== undefined
                    })

                const datas: ChartData = {
                    labels: labels,
                    datasets: [
                        {
                            label: `Répartition des famille de produits achetés`,
                            data: data,
                            backgroundColor: data.map((x, index) => colors[index]),
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                }

                // prettier-ignore
                const that = this;
                const options = Object.assign(baseOptions, {
                    onClick: function() {
                        if (!that.chart) return

                        const activeEl = that.chart.getActiveElements()
                        if (activeEl.length == 0) return null

                        if (!that.chart.data.labels) return

                        const data = that.suiviConso?.codeFamille[activeEl[0].index]
                        if (data) {
                            that.codeFamilleSelectionne = data
                            that.$nextTick(() => that.generateChart())
                        }
                    }
                })

                return {
                    type: 'doughnut' as 'doughnut',
                    data: datas,
                    options: options
                }
            } else {
                const labels = Object.keys(this.suiviConso.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit)
                    .filter(function(x): x is string {
                        return x !== undefined
                    })
                    .sort((a, b) => a.localeCompare(b))
                const data = labels
                    .map(name => this.suiviConso?.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit[name])
                    .filter(function(x): x is number {
                        return x !== undefined
                    })

                const datas: ChartData = {
                    labels: labels,
                    datasets: [
                        {
                            label: `Répartition des produits achetés de la famille "${this.suiviConso.statsGlobalesFamilles[this.codeFamilleSelectionne].libelleFamille}}"`,
                            data: data,
                            backgroundColor: data.map((x, index) => colors[index]),
                            datalabels: {
                                display: false
                            }
                        }
                    ]
                }

                return {
                    type: 'doughnut' as 'doughnut',
                    data: datas,
                    options: baseOptions
                }
            }
        },
        listeFamilles() {
            if (this.suiviConso) {
                return _.chain(this.suiviConso.codeFamille)
                    .map(code => ({
                        label: this.suiviConso?.statsGlobalesFamilles[code].libelleFamille,
                        code: code,
                        data: this.suiviConso?.statsGlobalesFamilles[code].nombreArticle
                    }))
                    .filter(function(x) {
                        return x.data !== undefined
                    })
                    .orderBy(a => a.label)
                    .value()
            }
        },
        listeProduitsCodeFamille: function() {
            if (this.suiviConso && this.codeFamilleSelectionne) {
                const labels = Object.keys(this.suiviConso.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit).filter(function(x): x is string {
                    return x !== undefined
                })
                return _.chain(labels)
                    .map(name => {
                        return {
                            data: this.suiviConso?.statsGlobalesFamilles[this.codeFamilleSelectionne].nombreArticlePourProduit[name],
                            label: name
                        }
                    })
                    .filter(function(x) {
                        return x.data !== undefined
                    })
                    .orderBy(a => a.label)
                    .value()
            }
        }
    },

    methods: {
        onCompanyChange() {
            this.chirurgienFiltre = ''
            this.reload()
        },
        onChirurgienChange(){
            this.reload()
        },
        reload() {
            const loadSuiviCA = this.loadSuiviCA()
            if (loadSuiviCA) loadSuiviCA.then(() => this.generateChart())
        },
        generateChart() {
            if (!this.config) return

            if (this.chart) this.chart.destroy()

            const canvas = document.getElementById('ctx-chart')
            if (!canvas) return

            if (this.isMobileDevice() && this.codeFamilleSelectionne) {
                canvas.style.display = 'none'
            } else {
                canvas.style.display = 'block'
                const ctx = (canvas as HTMLCanvasElement).getContext('2d')
                if (!ctx) return

                // @ts-ignore
                this.chart = new Chart(ctx, this.config)
            }
        },
        formatDate(date: Date) {
            return new Date(date).toLocaleDateString('fr-FR')
        },
        deleteCodeFamilleSelectionne() {
            this.codeFamilleSelectionne = ''
            this.generateChart()
        },
        chooseFamille(data: string) {
            this.codeFamilleSelectionne = data
            this.generateChart()
        }
    }
})
